import { GET_USER_FROM_SESSION } from 'actions/Types';

export default (state = null, action) => {
  if (action.type === `${GET_USER_FROM_SESSION}_SUCCESS`) {
    return action.payload;
  }

  if (action.type === `${GET_USER_FROM_SESSION}_FAILURE`) {
    return null;
  }

  return state;
};
